export const MAX_WIDTH = 600
